import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { type ReactNode, useEffect } from "react";
import { API_SCOPE } from "./msal.js";

type Props = { children: ReactNode };

export function AuthGate({ children }: Props) {
  const { instance, inProgress } = useMsal();
  const authed = useIsAuthenticated();

  useEffect(() => {
    if (inProgress === "none" && !authed) {
      void instance.loginRedirect({ scopes: [API_SCOPE] });
    }
  }, [instance, inProgress, authed]);

  if (!authed) {
    return (
      <div className="mx-auto max-w-md p-6">
        <h1 className="text-xl font-semibold">Signing you in…</h1>
        <p className="mt-2 text-sm text-slate-600">
          Redirecting to Microsoft sign-in.
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
